import React, { useEffect, useState } from 'react';
import cn from 'classnames';

import Modal from '../../common/ui/Modal';
import DeviceStatus from '../DeviceStatus';
import CopyToClipboard from '../../common/features/CopyToClipboard';
import EyeIcon from '../../../assets/icons/common/EyeIcon';
import { getDeviceSn, isCpeDevice } from '../../../utils/helpers';
import { getPlanAmountFromName } from '../../../utils/plans';
import { MOUSEFLOW_MASKED } from '../../../constants/mouseflowClasses';

import styles from './styles.module.scss';

const DeviceDetailsModal = ({ subscription, isOpen, toggleDetailModal }) => {
  const device_info = subscription?.meta?.device_info || {};
  const expired = !!subscription?.cancelled_at;
  const title = subscription?.meta?.title;
  const type_image_url = subscription?.meta?.billingIcon;
  const cpeDevice = isCpeDevice(device_info?.device_type_name);
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState('••••••••••');
  const {
    connection_status_name,
    device_type_name,
    device_version,
    wifi_ssid,
  } = device_info;
  const deviceSn = getDeviceSn(subscription?.properties);
  const planAmount = getPlanAmountFromName(subscription?.variant_title);

  const togglePasswordView = (e) => {
    e.preventDefault();
    setShowPassword(!showPassword);
  };

  const updatePassword = () => {
    let newPassword = showPassword ? device_info?.wifi_password : '••••••••••';
    setPassword(newPassword);
  };

  useEffect(() => {
    updatePassword();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showPassword]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={toggleDetailModal}
      className={styles.detailsModal}
    >
      <h3 className={cn(styles.detailsModalTitle)}>{title}</h3>
      <div className={styles.detailsModalRow}>
        <DeviceStatus
          connectionStatusName={connection_status_name}
          className={styles.detailsModalItem}
          isExpired={expired}
        ></DeviceStatus>
      </div>

      {!cpeDevice && (
        <div className={styles.detailsModalRow}>
          {wifi_ssid && (
            <div className={styles.detailsModalItem}>
              <span>WiFi Network</span>
              <p>{wifi_ssid}</p>
            </div>
          )}
          <div
            className={cn(styles.detailsModalItem, styles.detailsModalItemPass)}
          >
            <span>WiFi Key</span>
            <p className={MOUSEFLOW_MASKED}>
              {password}{' '}
              <button onClick={togglePasswordView}>
                <EyeIcon></EyeIcon>
              </button>
            </p>
          </div>
        </div>
      )}
      <div className={styles.detailsModalRow}>
        <div
          className={cn(
            styles.detailsModalItem,
            styles.detailsModalItemDeviceTypeName,
          )}
        >
          <span>Device Type</span>
          <p>
            <img src={type_image_url} alt={device_type_name} />
            {device_type_name}
          </p>
        </div>
        {device_version && (
          <div className={styles.detailsModalItem}>
            <span>Version</span>
            <p>{device_version}</p>
          </div>
        )}
      </div>
      <div className={styles.detailsModalRow}>
        <div className={cn(styles.detailsModalItem, styles.detailsModalItemSn)}>
          <span>Serial Number</span>
          <p>
            {deviceSn}
            <CopyToClipboard text={deviceSn}></CopyToClipboard>
          </p>
        </div>
        <div className={styles.detailsModalItem}>
          <span>Plan</span>
          <p>{planAmount}GB</p>
        </div>
      </div>
    </Modal>
  );
};

export default DeviceDetailsModal;
